import {Component, EventEmitter, Input, NgZone, OnInit, Output} from '@angular/core';
import {AnexosService} from '../../services/anexos.service';
import {ToastrService} from 'ngx-toastr';
import {SolicitacoesService} from '../../services/solicitacoes.service';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-modal-solicitar-acesso-producao',
  templateUrl: './modal-solicitar-acesso-producao.component.html',
  styleUrls: ['./modal-solicitar-acesso-producao.component.scss'],
})
export class ModalSolicitarAcessoProducaoComponent implements OnInit {

  carregando = false;
  @Input() corPrimaria: string;
  @Input() corSecundaria: string;
  @Input() solicitacao: any;
  @Output() fecharModal = new EventEmitter();
  pdfs: Array<any> = [];
  imagens: Array<any> = [];

  constructor(
    private anexosService: AnexosService,
    private toastService: ToastrService,
    private ngZone: NgZone,
    private solicitacoesService: SolicitacoesService,
    private loading: NgxSpinnerService,
  ) {}

  ngOnInit() {
    this.solicitacao.portfolioSolicitado.servicos.forEach((s: any) => {
      s.accordion = true;
    });
  }

  fechar(update: boolean) {
    this.fecharModal.emit(update);
  }

  async handleFileSelected(data: any) {
    try {
      await this.ngZone.run(() => {
        data.arquivo.id = Date.now();
        if (data.isImagem) {
          this.imagens.push(data.arquivo);
        } else {
          this.pdfs.push(data.arquivo);
        }
      });
    } catch ( e ) {
      console.log(e);
      this.toastService.error('Erro ao anexar o arquivo');
    }
  }

  async handelFileExcluded(data: any) {
    try {
      if (data.isImagem) {
        this.imagens.splice(data.index, 1);
      } else {
        this.pdfs.splice(data.index, 1);
      }
    } catch ( e ) {
      console.log(e);
      this.toastService.error('Erro ao remover o anexo');
    }
  }

  async concluir() {
    if (this.pdfs.length === 0 && this.imagens.length === 0) {
      this.toastService.error('É necessário anexar ao menos um arquivo');
      return;
    }
    const arrayPromissesAnexo: Array<any> = [];
    if (this.imagens.length) {
      this.imagens.forEach((i: any) => {
        arrayPromissesAnexo.push(
          this.anexosService.uploadAnexo(i.src.slice(i.src.indexOf('base64,') + 7),
            this.solicitacao.solicitacao.idSolicitacao, i.nome).toPromise());
      });
    }
    if (this.pdfs.length) {
      this.pdfs.forEach((pdf: any) => {
        arrayPromissesAnexo.push(
          this.anexosService.uploadAnexo(pdf.src.slice(pdf.src.indexOf('base64,') + 7),
            this.solicitacao.solicitacao.idSolicitacao, pdf.nome).toPromise());
      });
    }

    this.carregando = true;
    const result = Promise.all(arrayPromissesAnexo);
    result.then(async () => {
      try {
        this.carregando = true;
        await this.solicitacoesService.enviarParaAprovacaoProducao({
          ano: this.solicitacao.solicitacao.nuAno,
          numero: this.solicitacao.solicitacao.nuSolicitacao
        });
        this.toastService.success('Solicitação de acesso ao ambiente de produção enviada com sucesso');
        this.fechar(true);
        this.carregando = false;
      } catch ( e ) {
        this.loading.hide();
        this.carregando = false;
        this.toastService.error('Erro ao solicitar acesso ao ambiente de produção');
      }
    }, () => {
      this.carregando = false;
      this.toastService.error('Ocorreu um erro ao anexar os arquivos');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-solicitar-acesso-producao/modal-solicitar-acesso-producao.component.ts